import * as types from './mutation-types'

export const loadLots = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/lots/collection', data).then((response) => {
            commit(types.ADD_LOTS, response.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateLot = ({ commit }, data) => {

    return new Promise((resolve, reject) => {
        window.axios.patch('update/' + data.id + '/lot', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const createLot = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/lot', data).then((response) => {
            commit(types.ADD_LOT, response.data.lot)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}



export const deleteLot = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/' + id + '/lot').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

